import React from "react";

const ModalEdit = ({ show, onClose, children }) => {
  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: "1px", // Adjusted to position the modal at the bottom
        right: "12px", // Adjusted to position the modal at the right
        width: "35vw", // Allow the modal to adjust its width
        display: "flex",
        justifyContent: "flex-end", // Align modal content to the right
        alignItems: "flex-end", // Align modal content to the bottom
        zIndex: 10,
        borderRadius: "20px",
        overflow: "hidden",
        boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
        transition: "opacity 0.3s ease-in-out",
        opacity: show? 1 : 0,
      }}
    >
      <div
        style={{
          backgroundColor: "#EFEFEF",
          padding: "20px",
          backgroundColor: "#2F2E40",
          minWidth: "35vw",
          position: "relative",
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "10px",
            right: "15px",
            background: "none",
            border: "none",
            fontSize: "18px",
            cursor: "pointer",
            color: "white",
          }}
        >
          &times;
        </button>
        {children}
      </div>
    </div>
  );
};

export default ModalEdit;
